import { render, staticRenderFns } from "./PresentarRespuesta.vue?vue&type=template&id=4d87e5b3&scoped=true&lang=pug&"
import script from "./PresentarRespuesta.vue?vue&type=script&lang=js&"
export * from "./PresentarRespuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87e5b3",
  null
  
)

export default component.exports